import { createSelector } from '@ngrx/store';

import { ParameterResult } from '@models/swagger';
import { State } from './reducer';
import { selectHomeRegimeState } from '../selectors';

export const getData = createSelector(selectHomeRegimeState, (state: State) => state.data);

export const getError = createSelector(selectHomeRegimeState, (state: State) => state.error);

export const getLoading = createSelector(selectHomeRegimeState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: ParameterResult) => T) =>
  createSelector(selectHomeRegimeState, (state: State) => fn(state.data));
